import React from 'react';
import ReactGA from "react-ga4"
import Hero from "./components/Hero";
import Main from "./components/Main";
// import Nav from "./components/Nav";
import Footer from "./components/Footer";

const App = () => {
    ReactGA.initialize("G-4WRF2BXF4L")
    // ReactGA.event(window.location.pathname)
    // ReactGA.send({ hitType: "pageview", page: window.location.pathname })
    ReactGA.send("pageview")

    return (
        <html>
            <body className="hide-scrollbar">
                <Hero />
                <Main />
                <Footer />
            </body>
        </html>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js